import React, { ChangeEvent } from 'react';
import { Modal, Button, Label, Textarea } from "flowbite-react";
import CustomThemeModal from '../CustomThemes/CustomThemeModal';
import { HiOutlineExclamationCircle } from "react-icons/hi";

import StatusLabel from "../UtilityHelpers/StatusLabel";

type UpdateStatusModalPropType = {
    openModal: boolean,
    setOpenModal: (value: boolean) => void,
    requestID: number,
    newStatus: string,
    remarks: string,
    handleInputChange: (e: ChangeEvent<HTMLTextAreaElement>) => void,
    handleChangeStatus: () => void,
}

const UpdateStatusModal = ({openModal, setOpenModal, requestID, newStatus, remarks, handleInputChange, handleChangeStatus}: UpdateStatusModalPropType) => {

    return (
        <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} theme={CustomThemeModal} popup>
            <Modal.Body>
            <div className="text-center">            
                <h3 className="mt-5 mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to update the request with ID #{requestID} to <StatusLabel statusLabel={newStatus} /> status?
                </h3>
                { (newStatus === "Waitlisted" || newStatus === "Declined") && (
                <div className="mb-5">
                    <div className="mb-2 block text-left">
                    <Label htmlFor="comment" value="Add Remarks to Email" />
                    </div>
                    <Textarea rows={4} value={remarks} onChange={handleInputChange} />
                </div>
                ) }            
                <div className="flex justify-center gap-4">
                <Button color="success" onClick={() => handleChangeStatus()}>
                    {"Yes, I'm sure"}
                </Button>
                <Button color="gray" onClick={() => setOpenModal(false)}>
                    No, cancel
                </Button>
                </div>
            </div>
            </Modal.Body>
        </Modal>
    )
}

export default UpdateStatusModal;
